import { LatLng } from '..';

export const mapPolyline = (item) => ({
  lat: Number(item.lat),
  lng: Number(item.lng),
}) as LatLng;
